import { render, staticRenderFns } from "./AppCollapseItem.vue?vue&type=template&id=7aa907ca&scoped=true&"
import script from "./AppCollapseItem.vue?vue&type=script&lang=js&"
export * from "./AppCollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./AppCollapseItem.vue?vue&type=style&index=0&id=7aa907ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa907ca",
  null
  
)

export default component.exports